<template>
	<div class="MerchantSettled">
		<div class="w MerchantSettled_box">
			<div class="MerchantSettled_title">入驻申请</div>
			<div style="margin: 0 auto; width: 1000px">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px">
					<div class="littleTitleBox">
						<div class="littleTitle_text">入驻信息登记</div>
					</div>
					<div class="infoBox">
						<el-form-item label="入驻类型" prop="type" class="infoItem">
							<el-select v-model="ruleForm.type" placeholder="请选择企业类型" style="width: 100%">
								<!-- <el-option label="个人" :value="1"></el-option> -->
								<el-option label="企事业单位" :value="2"></el-option>
								<!-- <el-option label="政府" :value="3"></el-option> -->
							</el-select>
						</el-form-item>
						<!-- 个人部分 -->
						<template v-if="ruleForm.type === 1">
							<el-form-item label="姓名" prop="name" class="infoItem">
								<el-input v-model="ruleForm.name" placeholder="请输入姓名" style="width: 100%"></el-input>
							</el-form-item>
							<el-form-item label="身份证号" prop="idCard" class="infoItem">
								<el-input v-model="ruleForm.idCard" placeholder="请输入身份证号" style="width: 100%"></el-input>
							</el-form-item>
							<el-form-item label="手机号码" prop="contactNumber" class="infoItem">
								<el-input v-model="ruleForm.contactNumber" placeholder="请输入手机号码"
									style="width: 100%"></el-input>
							</el-form-item>
							<el-form-item label="电子邮箱" prop="email" class="infoItem">
								<el-input v-model="ruleForm.email" placeholder="请输入电子邮箱" style="width: 100%"></el-input>
							</el-form-item>
							<el-form-item label="职业" class="infoItem">
								<el-select v-model="ruleForm.occupation" placeholder="请选择职业" style="width: 100%">
									<el-option :label="item.label" :value="item.label"
										v-for="item in occupationOptions"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="所在地" prop="provinceId" class="infoItem">
								<citySingle @getCityInfo="getCityInfoFun"></citySingle>
							</el-form-item>
							<el-form-item label="单位名称" prop="unitName" class="infoItem">
								<el-input v-model="ruleForm.unitName" placeholder="请输入单位名称" style="width: 100%"></el-input>
							</el-form-item>
							<el-form-item label="应用领域" prop="areas" class="infoItem">
								<el-select v-model="ruleForm.areas" style="width: 100%" placeholder="请选择您的应用领域" multiple>
									<el-option :label="item.label" :value="item.value"
										v-for="item in applyFieldOptions"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="个人介绍" style="width: 100%;">
								<el-input type="textarea" v-model="ruleForm.introduce" :rows="5" maxlength="10000"
									show-word-limit></el-input>
							</el-form-item>
						</template>
						<!-- 企业和政府部分 -->
						<template v-else>
							<el-form-item :label="ruleForm.type == 2 ? '企业名称' : '机构名称'" prop="name" class="infoItem">
								<el-input v-model="ruleForm.name" style="width: 100%"
									:placeholder="ruleForm.type == 2 ? '请输入企业名称' : '请输入机构名称'"></el-input>
							</el-form-item>
							<el-form-item :label="ruleForm.type == 2 ? '企业地址' : '机构地址'" prop="address" class="infoItem">
								<el-input v-model="ruleForm.address" style="width: 100%"
									:placeholder="ruleForm.type == 2 ? '请输入企业地址' : '请输入机构地址'"></el-input>
							</el-form-item>
							<el-form-item v-if="ruleForm.type == 2" label="注册资金(万)" prop="registeredCapital"
								class="infoItem">
								<el-input-number v-model="ruleForm.registeredCapital" placeholder="请输入注册资金" id="phone"
									:controls="false" style="width: 100%"></el-input-number>
							</el-form-item>
							<el-form-item v-if="ruleForm.type == 2" label="法人姓名" prop="legalPerson" class="infoItem">
								<el-input v-model="ruleForm.legalPerson" placeholder="请输入法人姓名"
									style="width: 100%"></el-input>
							</el-form-item>
							<el-form-item :label="ruleForm.type == 2 ? '社会信用代码' : '机构码'" prop="creditCode" class="infoItem">
								<el-input v-model="ruleForm.creditCode"
									:placeholder="ruleForm.type == 2 ? '请输入统一社会信用代码' : '请输入机构码'"
									style="width: 100%"></el-input>
							</el-form-item>
							<el-form-item v-if="ruleForm.type == 2" label="法人身份证号" prop="idCard" class="infoItem" required>
								<el-input v-model="ruleForm.idCard" placeholder="请输入法人身份证号" style="width: 100%"></el-input>
							</el-form-item>
							<el-form-item label="所在地" prop="provinceId" class="infoItem" required>
								<citySingle @getCityInfo="getCityInfoFun"></citySingle>
							</el-form-item>
							<el-form-item label="应用领域" prop="areas" class="infoItem">
								<el-select v-model="ruleForm.areas" style="width: 100%;" multiple>
									<el-option :label="item.label" :value="item.value"
										v-for="item in applyFieldOptions"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="单位介绍" prop="introduce" style="width: 100%;">
								<el-input type="textarea" v-model="ruleForm.introduce" :rows="3"
									placeholder="请输入单位介绍"></el-input>
							</el-form-item>
							<el-form-item label="经营范围" prop="businessScope" style="width: 100%;">
								<el-input type="textarea" v-model="ruleForm.businessScope" :rows="3"
									placeholder="请输入经营范围"></el-input>
							</el-form-item>
						</template>
					</div>

					<div v-if="ruleForm.type == 1">
						<div class="littleTitleBox">
							<div class="littleTitle_text need">上传身份证或其他证明扫描件</div>
						</div>
						<div style="padding:0 130px;">
							<el-upload class="upload-demo" :action="this.$const.common.fileUpload"
								style="margin-bottom:20px;width:51%;" :on-change="upLoadFileChange"
								:on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="3"
								:on-exceed="handleExceed" :file-list="fileList">
								<el-button size="small" type="primary">点击上传</el-button>
								<div slot="tip" class="el-upload__tip">
									点击文件进行上传，支持pdf 与jpg格式文件
								</div>
							</el-upload>
						</div>
					</div>
					<div v-else>
						<div class="littleTitleBox">
							<div class="littleTitle_text need">上传营业执照或其他证明扫描件</div>
						</div>
						<div style="padding:0 130px;">
							<el-upload class="upload-demo" :action="this.$const.common.fileUpload"
								style="margin-bottom:20px;width:51%;" :on-change="upLoadFileChange"
								:on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="3"
								:on-exceed="handleExceed" :file-list="fileList">
								<el-button size="small" type="primary">点击上传</el-button>
								<div slot="tip" class="el-upload__tip">
									点击文件进行上传，支持pdf 与jpg格式文件
								</div>
							</el-upload>
						</div>
					</div>

					<div class="littleTitleBox">
						<div class="littleTitle_text">店铺信息</div>
					</div>
					<div class="infoBox">
						<el-form-item label="店铺名称" prop="shopInfo.shopName" style="width: 100%;">
							<el-input v-model="ruleForm.shopInfo.shopName" placeholder="请输入店铺名称"></el-input>
						</el-form-item>
						<el-form-item label="店铺介绍" style="width: 100%;">
							<el-input type="textarea" :rows="3" placeholder="请输入店铺介绍"
								v-model="ruleForm.shopInfo.shopIntroduce"></el-input>
						</el-form-item>
						<el-form-item label="负责人姓名" prop="shopInfo.headManName" class="infoItem">
							<el-input v-model="ruleForm.shopInfo.headManName" placeholder="请输入店铺负责人姓名"></el-input>
						</el-form-item>
						<el-form-item label="联系电话" prop="shopInfo.shopPhone" class="infoItem">
							<el-input v-model="ruleForm.shopInfo.shopPhone" placeholder="请输入店铺的联系电话"></el-input>
						</el-form-item>
						<el-form-item label="服务时间" prop="shopInfo.serviceDate" style="width: 100%;">
							<el-select v-model="ruleForm.shopInfo.serviceDate" multiple
								style="width: 42.5%;margin-right: 16px;">
								<el-option :label="item" :value="item" v-for="(item, index) in businessWeek"></el-option>
							</el-select>
							<el-time-select placeholder="起始时间" v-model="ruleForm.shopInfo.serviceBeginTime"
								style="margin-right: 12px;"
								:picker-options="{ start: '00:00:00', step: '1:00:00', end: '24:00:00' }">
							</el-time-select>-
							<el-time-select placeholder="结束时间" v-model="ruleForm.shopInfo.serviceEndTime"
								style="margin-left: 12px;"
								:picker-options="{ start: '00:00:00', step: '1:00:00', end: '24:00:00', minTime: ruleForm.shopInfo.serviceBeginTime }">
							</el-time-select>
						</el-form-item>
						<el-form-item label="服务热线" prop="shopInfo.serviceHotline" class="infoItem">
							<el-input v-model="ruleForm.shopInfo.serviceHotline" placeholder="请输入店铺的服务热线"></el-input>
						</el-form-item>
						<el-form-item label="电子邮件" prop="shopInfo.shopEmail" class="infoItem">
							<el-input v-model="ruleForm.shopInfo.shopEmail" placeholder="请输入店铺联系的电子邮件"></el-input>
						</el-form-item>
					</div>

					<el-form-item label="" prop="allowing">
						<el-checkbox-group v-model="ruleForm.allowing">
							<el-checkbox>
								我已阅读并同意
								<el-button type="text" @click.stop="readAgreement">
									《商业遥感交易服务平台用户协议》</el-button>
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm('ruleForm')">提交审核</el-button>
						<el-button @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>
				<el-dialog v-model="dialogShow" title="商业遥感交易服务平台用户协议" width="50%" :before-close="handleClose">
					<div id="wordView" v-html="wordText" style="width: 100%;height: 50vh;" />
				</el-dialog>

			</div>
		</div>
	</div>
</template>

<script>
import { regionDataPlus } from "element-china-area-data";
import IdentityCodeValid from "@/utils/checkIdent";
import citySingle from "@/components/citySingle.vue";
// let docx = require("docx-preview");
// 引入axios用来发请求
import mammoth from "mammoth";
// import axios from "axios";
export default {
	components: {
		citySingle
	},
	data() {
		var checkIdcard = (rule, value, callback) => {
			let data = value.toUpperCase(); //转换成大写
			if (!IdentityCodeValid(data)) {
				return callback(new Error("请输入正确的身份证号码"));
			} else {
				return callback();
			}
		};
		var checkAllowing = (rule, value, callback) => {
			if (!value) {
				return callback(new Error("请同意相关条款"));
			} else {
				return callback();
			}
		};
		return {
			fileList: [],
			options: regionDataPlus,
			occupationOptions: [
				{ label: '企事业单位人员', value: 0 },
				{ label: '教师', value: 1 },
				{ label: '学生', value: 2 },
				{ label: '其他', value: 3 }
			],
			applyFieldOptions: [
				{ label: '农业', value: 1 },
				{ label: '林业', value: 2 },
				{ label: '环境', value: 3 },
				{ label: '水利', value: 4 },
				{ label: '气象', value: 5 },
				{ label: '国土', value: 6 },
				{ label: '海洋', value: 7 },
				{ label: '城市', value: 8 },
				{ label: '其他', value: 9 }
			],
			businessWeek: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
			ruleForm: {
				type: 2, //	企业类型：商家类型：1.个人；2.企事业单位；3.政府
				name: "", // 姓名 - 企业名称
				idCard: '', // 身份证 - 法人身份证
				provinceId: '', // 省ID
				cityId: '', // 市ID
				countyId: '', // 县ID
				areas: '', // 应用领域
				introduce: '', // 个人介绍 - 企业介绍

				/* 个人部分 */
				contactNumber: '', // 电话
				email: '', // 电子邮件
				occupation: '', // 职业
				unitName: '', //单位名称

				/* 企业部分 */
				address: '', // 企业地址
				registeredCapital: '', // 注册资金
				legalPerson: '', // 法人姓名
				creditCode: '', // 信用代码
				businessScope: '', // 经营范围

				/* 店铺部分 */
				shopInfo: {
					shopName: '', //店铺名称
					shopIntroduce: '', // 店铺介绍
					headManName: '', // 负责人姓名
					shopPhone: '', // 店铺电话
					serviceDate: [], // 店铺营业周
					serviceBeginTime: '', // 店铺开始时间
					serviceEndTime: '', // 店铺结束时间
					serviceHotline: '', // 店铺服务热线
					shopEmail: '', // 店铺邮件
				},

				allowing: false, // 服务协议
			},
			rules: {
				type: [{ required: true, message: "请选择入驻类型", trigger: "change" }],
				name: [{ required: true, message: "请输入名称", trigger: "blur" }],
				idCard: [{ required: true, validator: checkIdcard, trigger: "blur" }],
				provinceId: [{ required: true, message: "请选择所在地", trigger: "change" }],
				contactNumber: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
				email: [{ required: true, message: "请输入电子邮箱", trigger: "blur" }],
				unitName: [{ required: true, message: "请输入单位名称", trigger: "blur" }],

				address: [{ required: true, message: "请输入企业地址", trigger: "blur" }],
				registeredCapital: [{ required: true, message: "请输入注册资金", trigger: "blur" }],
				legalPerson: [{ required: true, message: "请输入法人姓名", trigger: "blur" }],
				creditCode: [{ required: true, message: "请输入信用代码", trigger: "blur" }],

				'shopInfo.shopName': [{ required: true, message: "请输入店铺名称", trigger: "blur" }],
				'shopInfo.headManName': [{ required: true, message: "请输入负责人姓名", trigger: "blur" }],
				'shopInfo.shopPhone': [{ required: true, message: "请输入店铺电话", trigger: "blur" }],
				'shopInfo.serviceDate': [{ required: true, type: 'array', message: "请输入服务时间", trigger: "blur" }],
				'shopInfo.serviceHotline': [{ required: true, message: "请输入店铺的服务热线", trigger: "blur" }],
				'shopInfo.shopEmail': [{ required: true, message: "请输入店铺邮箱", trigger: "blur" }],

				allowing: [{ validator: checkAllowing, trigger: "blur" }],
			},
			dialogShow: false,
			wordText: "",
			wordURL: 'https://tpeos.cpeos.org.cn/dtpimg/data-trade-platform/7d7b22cfec0142c89fe6efb015064caa.docx',//文件地址
		};
	},
	beforeCreate() {
		if ([0, 1, 3].includes(this.$store.state.user.userInfo.supplierStatus)) {
			history.back()
		}
	},
	methods: {
		// 获取省市区信息
		getCityInfoFun(value) {
			this.ruleForm.countryId = value[0];
			this.ruleForm.provinceId = value[1];
			this.ruleForm.cityId = value[2];
			this.ruleForm.countyId = value[3];
		},
		// 文件上传操作按钮
		handleRemove(file, fileList) {
			this.fileList = fileList;
		},
		upLoadFileChange(file, fileList) {
			this.fileList = fileList;
		},
		handleExceed(files, fileList) {
			this.$message.warning(
				`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了
					${files.length + fileList.length} 个文件`
			);
		},
		beforeRemove(file) {
			return this.$confirm(`确定移除 ${file.name}？`);
		},
		// 协议跳转
		readAgreement() {
			console.log("打开协议页面");
			this.getWordText();
			//引入docx插件
			// axios({
			// 	method: "get",
			// 	responseType: "blob", // 因为是流文件，所以要指定blob类型
			// 	url: "https://www.cpeos.org.cn/personal/doc/protocol/platform-business.docx", // 自己的服务器，提供的一个word下载文件接口
			// }).then(({ data }) => {
			// 	console.log(data); // 后端返回的是流文件
			// 	docx.renderAsync(data, this.$refs.file); // 渲染到页面
			// 	this.dialogShow = true;
			// });
		},
		getWordText() {
				const xhr = new XMLHttpRequest();
				xhr.open("get", this.wordURL, true);
				xhr.responseType = "arraybuffer";
				xhr.onload = () => {
					if (xhr.status == 200) {
					mammoth.convertToHtml({ arrayBuffer: new Uint8Array(xhr.response) }).then((resultObject) => {
						this.$nextTick(() => {
						this.wordText = resultObject.value;
						});
					});
					}
				};
				xhr.send();
				this.dialogShow = true;

			},
		handleClose(){
			this.dialogShow = false;
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (!this.fileList.length) {
						this.$message.error('需要上传营业执照或其他证明扫描件')
						return '需要上传营业执照或其他证明扫描件'
					} else {
						this.ruleForm.certificationUrl = "";
						this.fileList.forEach(item => {
							this.ruleForm.certificationUrl = this.ruleForm.certificationUrl + item.response.data + ';'
						})
						this.ruleForm.shopInfo.serviceDate = this.ruleForm.shopInfo.serviceDate.join(',')
						if (this.ruleForm.shopInfo.serviceBeginTime.split(':').length === 2) {
							this.ruleForm.shopInfo.serviceBeginTime += ':00'
							this.ruleForm.shopInfo.serviceEndTime += ':00'
						}
						this.$http.post(this.$const.RemoteSensingMall.NewsupplierSave, this.ruleForm, true).then(res => {
							this.$message.success('提交入驻信息成功，1秒后返回');
							var that = this;
							setTimeout(function () {
								that.$router.go(-1)
							}, 1000)
						}).catch((error) => {
							console.log(error, 'error')
						});
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();

			this.fileList = []
			document.querySelector('.citySingle > .el-cascader input').value = null
			document.querySelectorAll('textarea, .el-select input').forEach(item => {
				item.value = null
			})
		},
	},
};
</script>

<style lang="scss" scoped>
.MerchantSettled {
	padding: 20px 0;
	background: #eff2f7;

	>.MerchantSettled_box {
		padding: 20px;
		background: #fff;
		box-shadow: 0px 0px 5px #ccc;

		>.MerchantSettled_title {
			margin: 20px 0;
			font-size: 28px;
			text-align: center;
			user-select: none;
		}

		.littleTitleBox {
			display: flex;
			align-items: center;
			margin-bottom: 20px;

			>.littleTitle_text {
				color: #1890ff;
				height: 30px;
				line-height: 30px;
				padding: 0 20px;
				border-bottom: 2px solid #1890ff;

				&.need::before {
					content: '*';
					color: #F56C6C;
				}
			}
		}

		.infoBox {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			align-items: center;

			>.infoItem {
				width: 50%;
			}
		}
	}
}

/deep/ #phone input {
	text-align: left !important;
}
</style>